import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "./utils";

export type WorkJobFeatureType = "contract_quantity_alert";
export type WorkJobType = "generate_automation_report";

export interface WorkJobStatus {
  status: "queued" | "actively_processing" | "halted" | "success";
  is_terminal: boolean;
}

type WorkJobStatusQueryData = Awaited<ReturnType<typeof fetchApiGet<WorkJobStatus>>>;

const WORK_JOB_STATUS_POLL_INTERVAL_MS = 5_000;

export function useGetWorkJobStatus({
  jobId,
  featureType,
  jobType,
  enabled,
}: {
  jobId?: string;
  featureType: WorkJobFeatureType;
  jobType: WorkJobType;
  enabled: boolean;
}) {
  const queryParams = new URLSearchParams();
  queryParams.set("feature_type", featureType);
  queryParams.set("job_type", jobType);

  return useQuery({
    queryKey: ["work-job-status", featureType, jobType, jobId],
    queryFn: () => fetchApiGet<WorkJobStatus>(`work/job/${jobId}/status`, queryParams),
    retry: 1,
    enabled: enabled && Boolean(jobId),
    refetchInterval: (data: WorkJobStatusQueryData | undefined): number | false => {
      if (data?.success && data.data.is_terminal) return false;
      return WORK_JOB_STATUS_POLL_INTERVAL_MS;
    },
  });
}
